<script setup>
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import OfflineBanner from './components/pwa/OfflineBanner.vue'
import PwaPublicHost from './components/pwa/PwaPublicHost.vue'
import PrivacyNotice from './components/pwa/PrivacyNotice.vue'
import { usePwaUpdate } from './composables/usePwaUpdate.js'
import { usePwaInstall } from './composables/usePwaInstall.js'
import { usePrivacyNotice } from './composables/usePrivacyNotice.js'
import { usePresence } from './composables/usePresence.js'
import { useTitleHint, shouldAnimateIntro } from './composables/useTitleHint.js'

const route = useRoute()
const isAdmin = computed(() => route.path.startsWith('/admin'))

// Intro d'ingresso (vedi useTitleHint): l'overlay PWA (pulsante "Installa app"
// / avviso aggiornamento) non deve comparire prima che tutta la UI sia svelata.
// Resta nascosto finché il titolo della Home non ha finito il suo effetto, poi
// compare in dissolvenza insieme al resto. Gate limitato alla Home (o al primo
// tick con route non ancora risolta) per non nasconderlo su /match/:id.
const { uiVeiled } = useTitleHint()
const animateIntro = shouldAnimateIntro()
const pwaIntroHidden = computed(() =>
  animateIntro && uiVeiled.value && (route.name === 'public-home' || route.name == null)
)

// Heartbeat presence (utenti connessi), unico per pubblico e admin.
usePresence()

// SW registrato sempre; UI install/update solo fuori da /admin.
const { needRefresh, update } = usePwaUpdate()
const { canInstall, promptInstall } = usePwaInstall()
const { dismissed: privacyDismissed, dismiss: dismissPrivacyNotice } = usePrivacyNotice()
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <OfflineBanner />
    <PrivacyNotice
      v-if="!isAdmin && !privacyDismissed"
      :intro-hidden="pwaIntroHidden"
      @dismiss="dismissPrivacyNotice"
    />
    <PwaPublicHost
      v-if="!isAdmin && privacyDismissed"
      :need-refresh="needRefresh"
      :can-install="canInstall"
      :intro-hidden="pwaIntroHidden"
      @update="update"
      @install="promptInstall"
    />
    <RouterView />
  </div>
</template>
